import { UserProfileRelationType } from '@/models/common';
import {
  DiagnosisCategoryType,
  DoctorDiagnosisFormType,
} from '@/models/diagnosis';
import { Client } from '@/types/app';
import {
  DiagnosisContactType,
  DiagnosisFormType,
  FamilyRelation,
  MedicalCategoryType,
} from '@/types/bff/gql-schema';
import { EDiagnosisContactType } from '@/types/diagnosis';

export const parseRumClientType = (client: Client): string => {
  if (!client.isMobile) {
    return client.clientType;
  }

  if (client.isIOS) {
    return `${client.clientType}-iOS`;
  }

  return `${client.clientType}-Android`;
};

export const parseDiagnosisFormTypeOf = (
  diagnosisFormType?: DoctorDiagnosisFormType,
) => {
  switch (diagnosisFormType) {
    case DoctorDiagnosisFormType.General:
      return DiagnosisFormType.General;
    case DoctorDiagnosisFormType.InHospitalDelivery:
      return DiagnosisFormType.InHospitalDelivery;
    default:
      return DiagnosisFormType.General;
  }
};

export const parseMedicalCategoryTypeOf = (
  type: DiagnosisCategoryType,
): MedicalCategoryType => {
  switch (type) {
    case DiagnosisCategoryType.Department:
      return MedicalCategoryType.Department;
    case DiagnosisCategoryType.Treatment:
      return MedicalCategoryType.Treatment;
  }
};

export const parseFamilyRelationOf = (
  relation: UserProfileRelationType,
): FamilyRelation => {
  switch (relation) {
    case UserProfileRelationType.Children:
      return FamilyRelation.Children;
    case UserProfileRelationType.Parents:
      return FamilyRelation.Parents;
    case UserProfileRelationType.Me:
      return FamilyRelation.Me;
    case UserProfileRelationType.Spouse:
      return FamilyRelation.Spouse;
  }
};

export const parseContactTypeOf = (
  contactType: EDiagnosisContactType,
): DiagnosisContactType => {
  switch (contactType) {
    case EDiagnosisContactType.F2F:
      return DiagnosisContactType.F2F;
    case EDiagnosisContactType.NonF2F:
    default:
      return DiagnosisContactType.NonF2F;
  }
};

export const convertToCurrencyCommaString = (amount: number): string => {
  return amount.toLocaleString('en');
};
